import { apiUrl } from '../../../settings'

export const ListAllAgentCommissionsUrl = () => {
  return apiUrl + '/advance-commission/list'
}

export const approveAdvanceCommissionUrl = () => {
  return apiUrl + '/advance-commission-request/approve'
}

export const ListAllApprovedAgentCommissionsUrl = () => {
  return apiUrl + '/advance-commission-approved/list'
}
